import {FC} from "react";
import {TransactionMainComponent} from "../../../components";
import {DailyTransactionTypeEnum, PageEnum} from "../../../models";

export const ShowPricePage: FC = ({}) => {
    //#region html
    return (
        <>
            <TransactionMainComponent
                formId={PageEnum.ShowPrice}
                transactionType={DailyTransactionTypeEnum.ShowPrice}
            />
        </>
    );
    //#endregion
};